module.exports = __webpack_public_path__ + "img/GDP-1-sp.26d01133.jpg";